<template>
    <div class="e6-title">
        <div class="title-wrapper">
            <h2 class="title-wrapper__name" v-if="this.$slots.default">
                <slot></slot>
            </h2>
            <i class="title-wrapper__tips" v-if="this.$slots.tips">
                <slot name="tips"></slot>
            </i>
        </div>
        <div class="title-wrapper-right" v-if="this.$slots.breadcrumb || this.$slots.operate">
            <div class="breadcrumb-wrapper" v-if="this.$slots.breadcrumb">
                <slot name="breadcrumb"></slot>
            </div>
            <div class="operate-wrapper" v-if="this.$slots.operate">
                <slot name="operate"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "E6Title"
    };
</script>
